import React, { useState, useEffect, useRef } from "react";
import { fetchHelicopterData, updateHelicopterStatusApi, handleVisibilityToggleApi, fetchExistingFiresApi, createFireInDatabase, deleteFireFromDatabase } from "../utils/api";
import HelicopterSidebar from "../components/helicopter-side-bar";
import useMap from "../hooks/useMap";
import { Helmet } from "react-helmet";
import swal from 'sweetalert';
import Navbar from "../components/navbar";
import "./home.css";
import { useTranslation } from "react-i18next";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import '../components/manage-helicopter-card.css'
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { getDistance } from 'geolib';
import { updateStatusText, filterHelicopters, addFlightPathToMap, displayDistanceAndTimeInfo } from "../utils/utils";
import { fetchExistingFires } from "../utils/fireManagement";
import FilterDropdown from '../components/filterDropdown';

mapboxgl.accessToken = "pk.eyJ1IjoiZmhzaW50IiwiYSI6ImNsYWNleWl3dDAycTYzbnBjdzdsc2drNG0ifQ.SRAl1VhLNL3_DztwVBPZYQ";

const Home = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const filterOptionRef = useRef("Show all");
  const [lng, setLng] = useState(7.7275985);
  const [lat, setLat] = useState(46.4167148);
  const [zoom, setZoom] = useState(5);
  const [id, setID] = useState("");
  const [Einsatzbereit_in, setEinsatzbereit_in] = useState("");
  const currentFlyLoc = {};
  const markers = {};
  const helicopterCurrLoc = [];
  const [helicopterData, setHelicopterData] = useState({});
  const [authRole, setAuthRole] = useState("");
  const { i18n, t } = useTranslation();
  const [currentFlightIndex, setCurrentFlightIndex] = useState(0);
  const [selectedFire, setSelectedFire] = useState(null);
  const selectedFireRef = useRef(null);
  const initialHelicopterLocationsRef = useRef([]);
  // Use the useMap hook
  const { mapContainer, map, addHelicopterClusterSourceAndLayers, resetHelicopterLocations } = useMap(
    lng, lat, zoom, selectedFireRef, setSelectedFire, helicopterCurrLoc, initialHelicopterLocationsRef, markers, currentFlyLoc, setHelicopterData, setCurrentFlightIndex
  );
  useEffect(() => {
    if (helicopterData && helicopterData.flights) {
      updateDisplayedFlight(helicopterData, currentFlightIndex);
    }
  }, [helicopterData, currentFlightIndex]);

  useEffect(() => {
    selectedFireRef.current = selectedFire;
  }, [selectedFire]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setAuthRole(base64_decode(role));
  }, []);

  useEffect(() => {
    apiCalling("add", false);
    fetchExistingFires(map.current, selectedFireRef, setSelectedFire);
    const intervalId = setInterval(() => {
      apiCalling("update", false);
      if (map.current) {
        fetchExistingFires(map.current, selectedFireRef, setSelectedFire);
      }
    }, 1000 * 30);

    return () => clearInterval(intervalId);
  }, [map]);
  
  const apiCalling = (type = "add", showLoading = false) => {
    if (showLoading) {
      setIsLoading(true);
    }
    fetchHelicopterData()
      .then((geojson) => {
        const filteredGeojson = filterHelicopters(geojson, filterOptionRef.current);
        updateHelicopterLocations(filteredGeojson);
        updateMapSourcesAndLayers(filteredGeojson);

        if (initialHelicopterLocationsRef.current.length === 0) {
          console.log("Setting initialHelicopterLocationsRef", helicopterCurrLoc);
          initialHelicopterLocationsRef.current = [...helicopterCurrLoc];
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (showLoading) {
          setIsLoading(false);
        }
      });
  };

  const updateHelicopterLocations = (filteredGeojson) => {
    console.log("Updating helicopter locations from updateHelicopterLocations");
    while (helicopterCurrLoc.length > 0) {
      helicopterCurrLoc.pop();

    }

    for (const key in filteredGeojson) {
      const lastFlightIndex = filteredGeojson[key]['flights'].length - 1;
      const lastFlight = filteredGeojson[key]['flights'][lastFlightIndex];
      const lastLength = lastFlight['tempGeoLine'].length - 1;

      filteredGeojson[key]['coordinates'] = lastFlight['tempGeoLine'][lastLength];
      filteredGeojson[key]['clusterTitle'] = filteredGeojson[key]['title'] + ",";
      helicopterCurrLoc.push({
        type: "Feature",
        properties: filteredGeojson[key],
        geometry: {
          coordinates: lastFlight['tempGeoLine'][lastLength],
          type: "Point"
        },
        id: key
      });
    }
  };

  const updateMapSourcesAndLayers = (filteredGeojson) => {
    for (const key in filteredGeojson) {
      const lastFlight = filteredGeojson[key]['flights'].slice(-1)[0];
      const lastLength = lastFlight['tempGeoLine'].length - 1;

      if (map.current.getSource('source-' + key)) {
        map.current.getSource('source-' + key).setData({
          'type': 'Feature',
          'properties': {
            'color': "#1c3351"
          },
          'geometry': {
            'type': 'LineString',
            'coordinates': lastFlight['tempGeoLine']
          }
        });
      } else {
        map.current.addSource('source-' + key, {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'properties': {
              'color': "#1c3351"
            },
            'geometry': {
              'type': 'LineString',
              'coordinates': lastFlight['tempGeoLine']
            }
          }
        });

        map.current.addLayer({
          'id': 'lines-' + key,
          'type': 'line',
          'source': 'source-' + key,
          'layout': {
            'line-join': 'round',
            'line-cap': 'round',
            'visibility': 'none'
          },
          'paint': {
            'line-color': ['get', 'color'],
            'line-width': 5
          }
        });
      }
    }

    if (!map.current.getSource('halicopters')) {
      console.log("updateMapSourcesAndLayers and addHelicopterClusterSourceAndLayers", helicopterCurrLoc);
        addHelicopterClusterSourceAndLayers();
    } else {
      map.current.getSource("halicopters").setData({ features: helicopterCurrLoc });
    }
  };

  const updateHelicopterStatus = async (value, row) => {
    setEinsatzbereit_in(row.HeliStatus);
    setID(row.id);
  
    try {
      const res = await updateHelicopterStatusApi(value, row.id);
      if (res.data.ResponseCode === 200) {
        updateMarkerAndSelectBox(value);
        updateStatusText(value, helicopterData.trackId);
        apiCalling();
        swal(t("helicopter.update.success"), {
          button: false,
          icon: "success",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateMarkerAndSelectBox = (value) => {
    const markerObj = document.getElementById(helicopterData.trackId);
    const selectObj = document.getElementById("select_box");
    const statusClasses = ['status1', 'status2', 'status3', 'status4', 'status5', 'status6', 'status7', 'status8'];

    statusClasses.forEach(status => {
      markerObj.classList.remove(status);
      selectObj.classList.remove(status);
    });

    markerObj.classList.add('status' + value);
    selectObj.classList.add('status' + value);
  };

  //FLIGHT HISTORY
  function updateDisplayedFlight(data, flightIndex) {
    console.log("Updating displayed flight in updateDisplayedFlight", data, flightIndex);
    if (typeof data.flights === 'string') {
        data.flights = JSON.parse(data.flights);
    }

    const selectedFlight = data.flights[flightIndex] || data.flights[data.flights.length - 1];
    const lastLength = selectedFlight['tempGeoLine'].length - 1;

    if (lastLength < 0) {
        console.error("Invalid flight data: No coordinates found in tempGeoLine");
        return;
    }

    const newCoordinates = selectedFlight['tempGeoLine'][lastLength];

    // Update the helicopter's current location in the data
    data['coordinates'] = newCoordinates;

    // Update the line on the map for the selected flight
    if (map.current.getSource('source-' + data.trackId)) {
        map.current.getSource('source-' + data.trackId).setData({
            'type': 'Feature',
            'properties': {
                'color': "#1c3351"
            },
            'geometry': {
                'type': 'LineString',
                'coordinates': selectedFlight['tempGeoLine']
            }
        });

        // Ensure the line is visible
        map.current.setLayoutProperty('lines-' + data.trackId, 'visibility', 'visible');
    } else {
        console.error(`Source 'source-${data.trackId}' not found`);
    }

    // Update the helicopter's location in the 'halicopters' source
    if (map.current.getSource('halicopters')) {
        const currentSourceData = map.current.getSource('halicopters')._data;
        const updatedFeatures = currentSourceData.features.map(feature => {
            if (feature.properties.heliId === data.heliId) {
                return {
                    ...feature,
                    geometry: {
                        ...feature.geometry,
                        coordinates: newCoordinates // Update geometry coordinates
                    },
                    properties: {
                        ...feature.properties,
                        coordinates: newCoordinates // Update properties coordinates
                    }
                };
            }
            return feature;
        });

        map.current.getSource("halicopters").setData({
            type: "FeatureCollection",
            features: updatedFeatures
        });
    } else {
        console.error("Source 'halicopters' not found");
    }

    // Finally, update the helicopter data in the state
    setHelicopterData(data);
}

  // Function to handle left arrow click
  const handlePrevFlight = () => {
    setCurrentFlightIndex(prevIndex => {
      const newIndex = (prevIndex === 0) ? helicopterData.flights.length - 1 : prevIndex - 1;
      updateDisplayedFlight(helicopterData, newIndex);
      return newIndex;
    });
  };
  
  // Function to handle right arrow click
  const handleNextFlight = () => {
    setCurrentFlightIndex(prevIndex => {
      const newIndex = (prevIndex === helicopterData.flights.length - 1) ? 0 : prevIndex + 1;
      updateDisplayedFlight(helicopterData, newIndex);
      return newIndex;
    });
  };

  //VISIBILITY UPDATE
const handleVisibilityToggle = async (id) => {
  const currentVisibility = helicopterData.visibility !== false;
  const newVisibility = !currentVisibility;

  try {
    const res = await handleVisibilityToggleApi(id, newVisibility);
    if (res.data.ResponseCode === 200) {
      // Update the local state immediately
      if (newVisibility === false) {
        setHelicopterData(prevData => ({
          ...prevData,
          Einsatzbereit_in: "7",
          visibility: newVisibility
        }));

        const markerObj = document.getElementById(helicopterData.trackId);
        markerObj.classList.remove('status1', 'status2', 'status3', 'status4', 'status5', 'status6', 'status7', 'status8');
        markerObj.classList.add('status7');

        const selectObj = document.getElementById("select_box");
        selectObj.classList.remove('status1', 'status2', 'status3', 'status4', 'status5', 'status6', 'status7', 'status8');
        selectObj.classList.add('status7');
        selectObj.value = "7"; // Set the select value to "7"

        document.getElementById("hali_status_" + helicopterData.trackId).innerHTML = "Abgemeldet N/A";
      }

      setHelicopterData(prevData => ({
        ...prevData,
        visibility: newVisibility
      }));

      // Update the marker's data attribute
      const markerElement = document.getElementById(helicopterData.trackId);
      if (markerElement) {
        const markerData = JSON.parse(markerElement.getAttribute('data-value'));
        markerData.visibility = newVisibility;
        markerElement.setAttribute('data-value', JSON.stringify(markerData));
      }

      apiCalling();
      swal(t("helicopter.update.success"), {
        button: false,
        icon: "success",
      });
    }
  } catch (error) {
    console.error("Error updating helicopter visibility:", error);
    swal(t("helicopter.visibility.update.error"), {
      button: false,
      icon: "error",
    });
  }
};

  const closePopup = (id) => {
    map.current.setLayoutProperty('lines-'+id, 'visibility', 'none');
    const elem = document.getElementById("left");
    const collapsed = elem.classList.toggle('collapsed');
    if (currentFlightIndex !== helicopterData.flights.length - 1) {
      resetHelicopterLocations();
    }
  }

  return (
    <div className="home-container">
      <Helmet>
        <meta property="og:title" content="Home" />
      </Helmet>
      <Navbar rootClassName="navbar-root-class-name"></Navbar>
      <div className="home-map2">
        {isLoading && <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>}
        <FilterDropdown 
        filterOptionRef={filterOptionRef} 
        onChange={(e) => {
          filterOptionRef.current = e.target.value;
          apiCalling("update", true);
        }}
      />
        <HelicopterSidebar
          helicopterData={helicopterData}
          authRole={authRole}
          setCurrentFlightIndex={setCurrentFlightIndex}
          currentFlightIndex={currentFlightIndex}
          handlePrevFlight={handlePrevFlight}
          handleNextFlight={handleNextFlight}
          updateHelicopterStatus={updateHelicopterStatus}
          handleVisibilityToggle={handleVisibilityToggle}
          closePopup={closePopup}
          t={t}
        />
        <div ref={mapContainer} className="map-container" />
      </div>
    </div>
  );
};

export default Home;